export const supportedLngs = ['en', 'es'];
